var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05_Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.45,5.338H18.213V2.45a1.05,1.05,0,0,0-1.05-1.05h-6.3a1.05,1.05,0,0,0-1.05,1.05V5.338H4.55a1.05,1.05,0,0,0,0,2.1H5.709L7.436,24.709A2.1,2.1,0,0,0,9.526,26.6h8.8a2.1,2.1,0,0,0,2.09-1.891L22.142,7.438H23.45a1.05,1.05,0,1,0,0-2.1ZM18.325,24.5h-8.8L7.846,7.7H20.005ZM11.213,2.8h5.6V5.338h-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,22.56a.617.617,0,0,0,.617-.616v-11.2a.617.617,0,0,0-1.234,0v11.2A.617.617,0,0,0,12.6,22.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4,22.56a.617.617,0,0,0,.617-.616v-11.2a.617.617,0,0,0-1.234,0v11.2A.617.617,0,0,0,15.4,22.56Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9597c2fe101a2ad225d42a429108c8f1.svg";
export { ForwardRef as ReactComponent };